
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/placements/add",
      function () {
        return require("private-next-pages/[locale]/placements/add/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/placements/add"])
      });
    }
  